import el from "@cypherpotato/el";
import { Row } from "./layout";
import { MutedText } from "./text";

export function LogRowItem(title, value) {
    return Row(
        el("div", MutedText(title), { style: { width: "30%" } }),
        el("div",
            value && el("span", value) || MutedText("-"), { style: { width: "70%" } }
        )
    )
}